var parser = require('./lib/parser');
var compiler = require('./lib/compiler');

module.exports = {
  parse: function(input) {
    var nodes = parser.parse(input.toString());
    return compiler.compile(nodes);
  }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/toml/index.js
// module id = 925
// module chunks = 37